import React from 'react';

import "./styles.css";

export default function Abas(props) {
  const { tabs, value, handleChange } = props;
  return (
    <div style={{display: "flex", flexDirection: "rows"}}>
      {tabs.map((t, i) => {
        const tabValue = t?.id ?? Number(i) + 3;
        const tabLabel = t?.label ?? t;
        const testId = t?.id ? `aba-faturamento-${t.id}` : `aba-faturamento-${i}`;

        return (
        <button
          key={tabValue}
          type="button"
          data-testid={testId}
          className={Number(value) === Number(tabValue) ? "aba-faturamento-on" : "aba-faturamento"}
          onClick={() => handleChange(tabValue)}
        >
          {tabLabel}
        </button>
        );
      })}
    </div>
  )
}
